import React, { useState } from 'react';
import { CreditCardIcon, MenuIcon, XIcon } from 'lucide-react';
export default function Header() {
  const [open, setOpen] = useState(false);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    setOpen(false);
  };
  const nav: {
    label: string;
    href: string;
    sectionId?: string;
  }[] = [{
    label: 'Inicio',
    href: '/'
  }, {
    label: 'Cómo funciona',
    href: '/#como-funciona',
    sectionId: 'como-funciona'
  }, {
    label: 'Simulador',
    href: '/#simulador',
    sectionId: 'simulador'
  }, {
    label: 'Contacto',
    href: '/#pre-registro',
    sectionId: 'pre-registro'
  }];
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string, sectionId?: string) => {
    if (sectionId) {
      e.preventDefault();
      scrollToSection(sectionId);
    } else if (href === '/') {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      setOpen(false);
    }
  };
  return <header className="sticky top-0 z-50 w-full border-b border-gray-200 bg-white/95 backdrop-blur" data-id="element-48">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-2 md:px-6 md:py-3" data-id="element-49">
        {/* Logo */}
        <a href="/" aria-label="Ir al inicio" className="flex items-center" data-id="element-50">
          <CreditCardIcon className="h-5 w-5 md:h-8 md:w-8 text-[#2B5FD9] mr-1.5 md:mr-2" data-id="element-51" />
          <span className="text-lg md:text-2xl font-bold text-[#0A1628]" data-id="element-52">
            Creditual
          </span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-5 md:flex" data-id="element-53">
          {nav.map(item => <a key={item.label} href={item.href} onClick={e => handleNavClick(e, item.href, item.sectionId)} className="text-sm text-[#6B7280] hover:text-[#0A1628] transition-colors" data-id="element-54">
              {item.label}
            </a>)}
          <button onClick={() => scrollToSection('simulador')} className="rounded-xl border border-[#2B5FD9] px-4 py-1.5 text-sm font-medium text-[#2B5FD9] hover:bg-[#2B5FD9]/10 transition-colors" data-id="element-55">
            Simular ingreso
          </button>
        </nav>

        {/* Mobile toggle */}
        <button type="button" aria-label={open ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={open} onClick={() => setOpen(v => !v)} className="inline-flex items-center justify-center rounded-md p-1.5 text-[#6B7280] md:hidden" data-id="element-56">
          {open ? <XIcon className="h-5 w-5" data-id="element-57" /> : <MenuIcon className="h-5 w-5" data-id="element-58" />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && <div className="border-t border-gray-200 bg-white md:hidden" data-id="element-59">
          <nav className="mx-auto flex max-w-7xl flex-col gap-0.5 px-4 py-1.5" data-id="element-60">
            {nav.map(item => <a key={item.label} href={item.href} onClick={e => handleNavClick(e, item.href, item.sectionId)} className="rounded-lg px-3 py-1.5 text-sm text-[#6B7280] hover:bg-gray-50" data-id="element-61">
                {item.label}
              </a>)}
            <button onClick={() => scrollToSection('simulador')} className="mt-1 rounded-xl border border-[#2B5FD9] px-3 py-1.5 text-sm font-medium text-[#2B5FD9] hover:bg-[#2B5FD9]/10 text-left" data-id="element-62">
              Simular ingreso
            </button>
          </nav>
        </div>}
    </header>;
}